import { EmployeeState } from "@/types/employeeState";

export const STEP_TO_ENROLLED_STATUS: Partial<Record<number, EmployeeState>> = {
  1: EmployeeState.TermsAccepted,
  2: EmployeeState.BeneficiaryAdded,
  3: EmployeeState.GoalAdded,
  4: EmployeeState.ContributionSet,
  5: EmployeeState.InvestmentOptionAdded,
};

export const ENROLLED_STATUS_TO_NEXT_STEP: Partial<Record<EmployeeState, number>> = {
  [EmployeeState.TermsAccepted]: 2,
  [EmployeeState.BeneficiaryAdded]: 3,
  [EmployeeState.GoalAdded]: 4,
  [EmployeeState.ContributionSet]: 5,
  [EmployeeState.InvestmentOptionAdded]: 6,
};

export const WIZARD_STATUS_ORDER: EmployeeState[] = [
  EmployeeState.TermsAccepted,
  EmployeeState.BeneficiaryAdded,
  EmployeeState.GoalAdded,
  EmployeeState.ContributionSet,
  EmployeeState.InvestmentOptionAdded,
];
